/**
* Web Service handler to send updated consumer information to the service
*
* @class UpdateConsumerInfoWS
*/
function UpdateConsumerInfoWS ( viewModel ) {
	var self = this;

	AbstractWS.apply( this, arguments );

	self.method		= ko.observable( 'POST' );
	self.name		= 'UpdateConsumerInfoWS';


	/**
	* API Endpoint
	*
	* @method serviceURL
	* @return {String}
	*/
	self.serviceURL	= ko.computed( function () {
		return '/qless/api/v1/kiosk/consumer';
	});


	/**
	* Collects information about the Consumer and passes it to the API
	*
	* @method updateConsumerInfo
	* @param {AppointmentModel} oAppointmentModel
	* @return none
	*/
	self.updateConsumerInfo = function ( oAppointmentModel ) {

		self.clearParams();

		var name = null;

		if ( oAppointmentModel.firstName() != null && oAppointmentModel.lastName() != null ) {
			name = oAppointmentModel.firstName() +' '+ oAppointmentModel.lastName();
		}
		else if ( oAppointmentModel.firstName() != null ) {
			name = oAppointmentModel.firstName();

		}
		else if ( oAppointmentModel.lastName() != null ) {
			name = oAppointmentModel.lastName();
		}

		if ( name == null && (oAppointmentModel.notes() == '' || oAppointmentModel.notes() == null) ){
			return;
		}

		if ( name != null ) {
			self.addParam( 'name', name );
		}

		if ( oAppointmentModel.email() != null && oAppointmentModel.email() != '' ) {
			self.addParam( 'email', oAppointmentModel.email() );
		}

		if ( oAppointmentModel.notes() == '' || oAppointmentModel.notes() == null ) {
			self.addParam( 'notes', oAppointmentModel.notes() );
		}

		self.addParam( 'sessionId', oAppointmentModel.sessionId );

		// Create a new endpoint with the correct queue id
		self.serviceURL = ko.computed( function () {
			return '/qless/api/v1/employee/queue/'+ oAppointmentModel.queueId +'/consumer';
		});

		self.doRequest();
	};


	/**
	* Updates consumer spot info with party size
	*
	* @method updatePartySize
	* @param {AppointmentModel} oAppointmentModel
	* @return none
	*/
	self.updatePartySize = function ( oAppointmentModel ) {
		if ( oAppointmentModel.partySize != null ) {
			self.clearParams();

			self.addParam( 'partySize', oAppointmentModel.partySize );
			self.addParam( 'sessionId', oAppointmentModel.sessionId );

			self.serviceURL = ko.computed( function () {
				return '/qless/api/v1/employee/queue/'+ oAppointmentModel.queueId +'/partySize';
			});

			self.doRequest();
		}
	};


	/**
	* Updates consumer spot info with phone number
	*
	* @method updatePhone
	* @param {AppointmentModel} oAppointmentModel
	* @return none
	*/
	self.updatePhone = function ( oAppointmentModel ) {
		if ( oAppointmentModel.phone != null ) {
			self.clearParams();

			self.addParam( 'newPhone', oAppointmentModel.phone );
			self.addParam( 'sessionId', oAppointmentModel.sessionId );

			self.serviceURL = ko.computed( function () {
				return '/qless/api/v1/employee/location/'+ oAppointmentModel.locationId +'/phone';
			});

			self.doRequest();
		}
	};


	/**
	* Updates consumer spot info with Transaction Type ID
	*
	* @method updateTransactionType
	* @param {AppointmentModel} oAppointmentModel
	* @return none
	*/
	self.updateTransactionType = function ( oAppointmentModel ) {
		if ( oAppointmentModel.transactionType() != null ) {
			self.clearParams();

			self.addParam( 'transactionType', oAppointmentModel.transactionType().id );
			self.addParam( 'sessionId', oAppointmentModel.sessionId );

			self.serviceURL = ko.computed( function () {
				return '/qless/api/v1/employee/queue/'+ oAppointmentModel.queueId +'/transactionType';
			});

			self.doRequest();
		}
	};


	/**
	* Returns the object to it's default state
	*
	* @method reset
	* @return none
	*/
	self.reset = function () {
		self.clearParams();

		self.serviceURL	= ko.computed( function () {
			return '/qless/api/v1/kiosk/consumer';
		});
	};

	return self;
};

UpdateConsumerInfoWS.prototype = AbstractWS.prototype;
UpdateConsumerInfoWS.prototype.constructor = UpdateConsumerInfoWS;
